export default function Contact() {
  return (
    <main className="main">
      <div className="page-hero fi">
        <div className="hero-tag">Contact</div>
        <h1>Vragen, ideeën of<br/><em>feedback</em>?</h1>
        <p>We horen graag van je. Stuur een mail en we reageren altijd binnen 2 werkdagen.</p>
      </div>

      <div style={{ width: "100%", maxWidth: 560, marginBottom: 48 }}>
        <div className="faq-item fi" style={{ textAlign: "center", padding: "32px 24px" }}>
          <div style={{ fontSize: 40, marginBottom: 14 }}>✉️</div>
          <div className="faq-q" style={{ fontSize: 18, marginBottom: 8 }}>hallo@givn.to</div>
          <div className="faq-a">
            Voor vragen, suggesties, samenwerkingen of technische problemen.
            We lezen alles en reageren persoonlijk.
          </div>
          <a href="mailto:hallo@givn.to"
            style={{
              display: "inline-block", marginTop: 20, background: "#C9856A", color: "white",
              textDecoration: "none", padding: "12px 28px", borderRadius: 50,
              fontWeight: 600, fontSize: 14, transition: "all 0.2s"
            }}>
            Mail ons →
          </a>
        </div>

        <div className="faq-item fi" style={{ marginTop: 12, textAlign: "center", padding: "24px" }}>
          <div style={{ fontSize: 28, marginBottom: 10 }}>📱</div>
          <div className="faq-q">Instagram</div>
          <div className="faq-a" style={{ marginBottom: 14 }}>
            Volg @givn.to voor updates, nieuwe functies en cadeauideeën.
          </div>
          <a href="https://instagram.com/givn.to" target="_blank" rel="noopener noreferrer"
            style={{
              display: "inline-block", background: "#F2E8DC", color: "#A86349",
              textDecoration: "none", padding: "10px 22px", borderRadius: 50,
              fontWeight: 600, fontSize: 14, border: "1.5px solid #EDE3D9"
            }}>
            @givn.to op Instagram
          </a>
        </div>
      </div>
    </main>
  );
}
